import { makeAutoObservable } from "mobx";
import { v4 } from "uuid";

const ALERT_ANIM_TIME = 250;

class _ApplicationState {
    alerts = [];
    currentPageHasUnsavedChanges = false;
    emulatorIsVisible = false;
    navIsOpen = false;

    constructor() {
        makeAutoObservable(this, {
        })
    }

    addAlert(variant, message, options = {dismissable: true, timeout: 5}) {
        const thisId = v4();
        this.alerts = [...this.alerts, {id: thisId, variant, message, options, classes: ['alert-fade']}];
        
        setTimeout(() => {
            this.alerts = this.alerts.map(i => i.id === thisId ? {...i, classes: []} : i);
        }, 1);

        if (options.timeout) {
            setTimeout(() => {
                this.removeAlert(thisId);
            }, options.timeout * 1000)
        }
    }

    removeAlert(id) {
        this.alerts = this.alerts.map(i => i.id === id ? {...i, classes: ['alert-fade']} : i);
        setTimeout(() => {
            this.alerts = this.alerts.filter(a => a.id !== id);
        }, ALERT_ANIM_TIME);
    }

    setCurrentPageUnsaved() {
        this.currentPageHasUnsavedChanges = true;
    }

    unsetCurrentPageUnsaved() {
        this.currentPageHasUnsavedChanges = false;
    }

    setEmulatorVisible() {
        this.emulatorIsVisible = true;
    }

    unsetEmulatorVisible() {
        this.emulatorIsVisible = false;
    }

    toggleNavIsOpen() {
        this.navIsOpen = !this.navIsOpen;
    }

    setNavClosed() {
        this.navIsOpen = false;
    }

}

const ApplicationState = new _ApplicationState();
export default ApplicationState;

window.addEventListener('beforeunload', function (e) {
    if (ApplicationState.currentPageHasUnsavedChanges) {
        // Cancel the event
        e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
        // Chrome requires returnValue to be set
        e.returnValue = '';          
    }
});

// Hack to make debugging easier. DO NOT EVER USE IN CODE
window.___ApplicationState = ApplicationState;